export default __webpack_public_path__ + "static/logo_partner@2x-232210901f18ddf72df26965b5114c15.png";